import React from "react";

export default function PriceBlock({ original, sale, variant = "card" }) {
  const save = original != null && sale != null ? original - sale : null;
  const showSave = save != null && save > 0;

  if (variant === "detail") {
    return (
      <div>
        <div className="flex items-baseline gap-2 mb-1">
          {original != null && (
            <span className="font-mono text-sm text-[#8e8e96] line-through">
              ${original.toLocaleString()}
            </span>
          )}
          <span className="font-heading text-3xl font-bold text-[#1c1c20]">
            ${sale != null ? sale.toLocaleString() : ""}
          </span>
        </div>
        {showSave && (
          <span className="text-[#7c3aed] text-sm font-semibold">
            Save ${save.toLocaleString()}
          </span>
        )}
      </div>
    );
  }

  return (
    <div>
      <div className="flex items-baseline gap-2 mb-1">
        {original != null && (
          <span className="font-mono text-sm text-[#8e8e96] line-through">
            ${original.toLocaleString()}
          </span>
        )}
        <span className="font-heading text-2xl font-bold text-[#1c1c20]">
          ${sale != null ? sale.toLocaleString() : ""}
        </span>
      </div>
      {showSave && (
        <span className="font-mono text-xs uppercase tracking-widest text-[#7c3aed]">
          Save ${save.toLocaleString()}
        </span>
      )}
    </div>
  );
}